(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', 'redux-form', '../validators', '../../svg/Eye', '../../svg/EyeSlash'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('redux-form'), require('../validators'), require('../../svg/Eye'), require('../../svg/EyeSlash'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classCallCheck, global.possibleConstructorReturn, global.inherits, global.react, global.reduxForm, global.validators, global.Eye, global.EyeSlash);
    global.VisiblePasswordField = mod.exports;
  }
})(this, function (exports, _classCallCheck2, _possibleConstructorReturn2, _inherits2, _react, _reduxForm, _validators, _Eye, _EyeSlash) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var _react2 = _interopRequireDefault(_react);

  var _Eye2 = _interopRequireDefault(_Eye);

  var _EyeSlash2 = _interopRequireDefault(_EyeSlash);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PasswordFieldToggle = function (_Component) {
    (0, _inherits3.default)(PasswordFieldToggle, _Component);

    function PasswordFieldToggle() {
      (0, _classCallCheck3.default)(this, PasswordFieldToggle);

      var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this));

      _this.state = {
        isPasswordVisible: false
      };
      return _this;
    }

    PasswordFieldToggle.prototype.togglePasswordVisibility = function togglePasswordVisibility() {
      this.setState({ isPasswordVisible: !this.state.isPasswordVisible });
    };

    PasswordFieldToggle.prototype.render = function render() {
      var isPasswordVisible = this.state.isPasswordVisible;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reduxForm.Field, {
          style: {
            width: '100%'
          },
          type: isPasswordVisible ? 'text' : 'password',
          id: 'password',
          name: 'password',
          component: 'input',
          label: 'Password',
          validate: [_validators.required]
        }),
        _react2.default.createElement(
          'div',
          {
            onClick: this.togglePasswordVisibility.bind(this),
            style: {
              height: '30px',
              width: '30px',
              position: 'relative',
              float: 'right',
              zIndex: 2,
              marginRight: '10px',
              marginTop: '-20px'
            }
          },
          isPasswordVisible ? _react2.default.createElement(_Eye2.default, null) : _react2.default.createElement(_EyeSlash2.default, null)
        )
      );
    };

    return PasswordFieldToggle;
  }(_react.Component);

  PasswordFieldToggle.propTypes = {};

  exports.default = (0, _reduxForm.reduxForm)({
    form: 'fieldLevelValidation'
  })(PasswordFieldToggle);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/form/fields/VisiblePasswordField.js
// module id = 2103
// module chunks = 1